<template>
    <div class="DataXC">
        <!-- 弹窗 -->
        <el-dialog :visible.sync="XCShow" custom-class="dialogQy-2" :show-close="true" destroy-on-close
            close-on-press-escape append-to-body width="70%" :modal="true" center title="巡检详情">
            <div>
                <div class="dialog-title">
                    <span class="dialog-title-left"></span>
                    <span>巡检信息</span>
                </div>
                <div class="dialog-text-item" style="margin-bottom: 20px;">
                    <div>巡检结果：<span class="cont-text-span">{{popData.inspectionResult==1?'达标':'不达标'}}</span></div>
                    <div>巡检人员：<span class="cont-text-span">{{rowData.inspector}}</span></div>
                </div>
                <div class="dialog-text-item" style="margin-bottom: 20px;">
                    <div>巡检时间：<span class="cont-text-span">{{rowData.inspectionTime}}</span></div>
                </div>
                <div class="dialog-text-item" style="margin-bottom: 20px;">
                    <div>备注：<span class="cont-text-span">{{rowData.remark}}</span></div>
                </div>
                <div class="imgBox">
                    <span>巡检图片：</span>
                    <img class="zsImg" v-for="(item,index) in inspectionImages" :key="index" :src="path+item" />
                </div>

                <div class="dialog-title mTop40">
                    <span class="dialog-title-left"></span>
                    <span>建筑安全隐患信息</span>
                </div>
                <div class="dialog-text-item">
                    <div>是否存在开裂:：<span class="cont-text-span">{{popData.hasCrack==1?'是':'否'}}</span></div>
                    <div>是否存在坍塌：<span class="cont-text-span">{{popData.hasCollapse==1?'是':'否'}}</span></div>
                    <div>检查是否通过：<span class="cont-text-span">{{popData.buildingCheckPass==1?'有':'无'}}</span></div>
                    <div>备注：<span class="cont-text-span">{{popData.buildingCheckReason}}</span></div>
                </div>
                <div class="dialog-title mTop40">
                    <span class="dialog-title-left"></span>
                    <span>消防设施设备信息</span>
                </div>
                <div class="dialog-text-item">
                    <div>灭火器是否完好：<span class="cont-text-span">{{popData.fireExtinguisherOk==1?'是':'无'}}</span></div>
                    <div>消防栓是否完好：<span class="cont-text-span">{{popData.hydrantOk==1?'是':'无'}}</span></div>
                    <div>烟雾报警器是否完好：<span class="cont-text-span">{{popData.smokeAlarmOk==1?'是':'无'}}</span></div>
                </div>
                <div class="dialog-text-item mTop20">
                    <div>灭火器是否过期：<span class="cont-text-span">{{popData.fireExtinguisherExpired==1?'是':'无'}}</span>
                    </div>
                    <div>消防栓是否过期：<span class="cont-text-span">{{popData.hydrantExpired==1?'是':'无'}}</span></div>
                    <div>烟雾报警器是否过期：<span class="cont-text-span">{{popData.smokeAlarmExpired==1?'是':'无'}}</span></div>
                </div>
                <div class="dialog-text-item mTop20">
                    <div>燃气报警装置是否安装：<span class="cont-text-span">{{popData.gasAlarmInstalled==1?'是':'无'}}</span></div>
                </div>
                <div class="dialog-text-item mTop20">
                    <div>检查是否通过：<span class="cont-text-span">{{popData.fireCheckPass==1?'是':'无'}}</span></div>
                </div>
                <div class="dialog-text-item mTop20">
                    <div>备注：<span class="cont-text-span">{{popData.fireCheckReason}}</span></div>
                </div>

                <div class="dialog-title mTop40">
                    <span class="dialog-title-left"></span>
                    <span>食品安全监管信息</span>
                </div>
                <div class="dialog-text-item">
                    <div>农家乐食材采购是否正规：<span class="cont-text-span">{{popData.foodPurchaseLegal==1?'是':'否'}}</span>
                    </div>
                    <div>检查食品是否过期：<span class="cont-text-span">{{popData.foodExpired==1?'是':'否'}}</span></div>
                    <div>餐具有无消毒设施：<span class="cont-text-span">{{popData.utensilDisinfection==1?'有':'无'}}</span></div>
                </div>
                <div class="dialog-text-item mTop20">
                    <div>检查是否通过：<span class="cont-text-span">{{popData.foodCheckPass==1?'是':'否'}}</span></div>
                </div>
                <div class="dialog-text-item mTop20">
                    <div>备注：<span class="cont-text-span">{{popData.foodCheckReason}}</span></div>
                </div>

                <div class="dialog-title mTop40">
                    <span class="dialog-title-left"></span>
                    <span>经营资质信息</span>
                </div>
                <div class="dialog-text-item">
                    <div>是否取得合法有效的营业执照：<span class="cont-text-span">{{popData.hasBusinessLicense==1?'是':'否'}}</span>
                    </div>
                    <div>是否取得合法有效的卫生许可证：<span class="cont-text-span">{{popData.hasHealthPermit==1?'是':'否'}}</span></div>
                </div>
                <div class="dialog-text-item mTop20">
                    <div>检查是否通过：<span class="cont-text-span">{{popData.licenseCheckPass==1?'是':'否'}}</span></div>
                </div>
                <div class="dialog-text-item mTop20">
                    <div>备注：<span class="cont-text-span">{{popData.licenseCheckReason}}</span></div>
                </div>

                <div class="dialog-title mTop40">
                    <span class="dialog-title-left"></span>
                    <span>实名登记信息</span>
                </div>
                <div class="dialog-text-item">
                    <div>是否落实实名登记制度：<span class="cont-text-span">{{popData.realNameRegistered==1?'是':'否'}}</span></div>
                </div>
                <div class="dialog-text-item mTop20">
                    <div>检查是否通过：<span class="cont-text-span">{{popData.registrationCheckPass==1?'是':'否'}}</span></div>
                </div>
                <div class="dialog-text-item mTop20">
                    <div>备注：<span class="cont-text-span">{{popData.registrationCheckReason}}</span></div>
                </div>



            </div>


        </el-dialog>
    </div>
</template>

<script>


    import { getInspectionsById } from '@/api/common.js'


    export default {

        data() {
            return {
                XCShow: false,
                popData: {},
                path: process.env.VUE_APP_BASE_API,
                rowData: {},
                inspectionImages: [],
            };
        },
        components: {

        },
        mounted() {
            // this.getList();

        },
        beforeDestroy() {

        },
        created() { },
        methods: {
            async init(row) {
                console.log('巡检详情的参数', row)
                this.rowData = row
                await this.getDateils(row)
                this.XCShow = true
            },
            // 查详情
            getDateils(row) {
                getInspectionsById({ id: row.id }).then(res => {
                    if (res.code == 200) {
                        this.popData = res.data
                        let imgs = res.data.inspectionImages
                        this.inspectionImages = imgs.split(',')
                    } else {
                        this.$message.error(res.msg || '网络错误');
                        return
                    }
                })
            },
            // 时间格式化
            format(date) {
                let time = new Date(date)
                const year = time.getFullYear();
                const month = (time.getMonth() + 1).toString().padStart(2, '0');
                const day = time.getDate().toString().padStart(2, '0');

                let hour = time.getHours() < 10 ? '0' + time.getHours() : time.getHours()
                let min = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()
                let ss = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds()

                // const formattedDate = `${year}-${month}-${day}`;
                const formattedDate = `${hour}:${min}:${ss}`;
                return formattedDate
            },

            getList() {

            },


        },
    };
</script>

<style lang="scss" scoped>
    ::v-deep .dialogQy-2 {
        background: #2D4E8A;

        .el-dialog__header {
            padding: 15px 0;
            background: #5275B5;

            .el-dialog__title {
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: normal;
                font-size: 24px;
                color: #FFFFFF;
            }

            .el-dialog__headerbtn {
                .el-dialog__close {
                    color: #fff;
                    font-size: 24px;
                }
            }
        }

        .el-dialog__body {
            padding: 15px 60px;
            max-height: 600px;
            box-sizing: border-box;
            overflow-y: auto;

            .dialog-title {
                display: flex;
                align-items: center;
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: normal;
                font-size: 16px;
                color: #9CD8FF;
                margin-bottom: 15px;

                .dialog-title-left {
                    width: 3px;
                    height: 20px;
                    background: #9CD8FF;
                    border-radius: 6px;
                    margin-right: 10px;
                }
            }

            .dialog-text-item {
                display: flex;
                align-items: center;
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: normal;
                font-size: 16px;
                color: #BDD9EC;

                .cont-text-span {
                    color: #FFFFFF;
                    margin-left: 10px;
                    margin-right: 50px;
                }


            }

            .basicInfo {
                .basicInfo-item {
                    display: flex;
                    font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                    font-weight: normal;
                    font-size: 16px;
                    color: #BDD9EC;

                    .basicInfo-text {
                        width: 15%;

                    }

                    .basicInfo-text:last-child {
                        width: 25%;
                    }

                    .cont-text-span {
                        color: #FFFFFF;
                        margin-left: 10px;
                    }

                    .zsImg {
                        width: 120px;
                        height: 80px;
                        background: #C4C4C4;
                        margin-left: 10px;
                    }

                    .text-top {
                        display: flex;
                        align-items: start;
                    }
                }
            }

            .roomInfo {

                .roomInfo-item {
                    display: inline-flex;
                    align-items: center;
                    width: 33%;
                    text-align: center;
                    font-family: Source Han Sans CN, Source Han Sans CN;
                    font-weight: 400;
                    font-size: 16px;
                    color: #FFFFFF;

                    .tet {
                        flex: 1;
                        height: 52px;
                        background: #5275B5;
                        border: 1px solid #8AB9FC;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }
            }

            .el-tabs {
                .el-tabs__item {
                    font-family: Source Han Sans CN, Source Han Sans CN;
                    font-weight: 400;
                    font-size: 16px;
                    color: #738CB2;
                }

                .is-active {
                    color: #0099FF;
                }

                .el-tabs__nav-wrap::after {
                    background-color: #738CB2 !important;
                }
            }


        }







        .dialog-titel-item {
            display: flex;
            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: normal;
            font-size: 12px;
            color: #FFFFFF;
            margin-bottom: 10px;

            .child1 {
                flex: 0.4,
            }

            .child2 {
                flex: 0.6,
            }
        }

        .deatl {
            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: normal;
            font-size: 12px;
            color: #FFFFFF;
            line-height: 18px;
        }

        .el-dialog__footer {
            padding-bottom: 10px;
        }

        .dialog-footer {

            .footer-btn {
                width: 116px;
                border-radius: 0;
                background: linear-gradient(180deg, #1F4277 0%, #34639A 100%);
                border: 1px solid #9FD9FF;
                font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
                font-weight: normal;
                font-size: 14px;
                color: #9FD9FF;
            }
        }
    }

    .mTop40 {
        margin-top: 40px;
    }

    .mTop20 {
        margin-top: 20px;
    }

    ::v-deep .tableBox {
        background: none;

        tr {
            background: none;

            th {
                background: none;
                color: #D8E7FF;
            }

            td {
                border: none;
                border-bottom: 1px solid #4A72A2;
                border-left: none;
                border-right: none;
                font-size: 16px;
            }
        }

        .has-gutter {
            border: 1px solid #9FD9FF;
        }

        .el-table__header-wrapper {
            border: 1px solid #9FD9FF;
        }

        .is-leaf {
            border: none;
        }

        .el-table__row {

            /* border: 1px solid #4A72A2; */
        }

        .el-table__cell {
            /* border: none; */
            border-left: none;
            border-right: none;
        }

        .el-table__header-wrapper {
            /* background: linear-gradient(180deg, #02265B 0%, #34639A 100%); */
            background: #5275B5;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #D8E7FF;
        }

        .el-table__row:nth-child(2n) {
            /* background: linear-gradient(180deg, #1F4277 0%, #34639A 100%); */
            background-color: #2D4E8A;
        }

        .el-table__row {
            font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
            font-weight: normal;
            font-size: 18px;
            color: #BFDDFF;
        }

        .even-row {
            background: none !important;

        }

        .el-table__row:hover {
            background: none !important;
            /* 设置悬停时的背景色 */
        }


    }

    ::v-deep .el-table::before {
        background: none;
    }

    /* 鼠标移入某一行的样式 */
    ::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
        background: #2D4E8A;
    }

    ::v-deep .el-table__body tr.current-row>td.el-table__cell {
        background-color: #2D4E8A;
    }

    .voper-pr {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #57A9FB;
    }


    ::v-deep .paginationBox {
        text-align: right;
        margin-top: 24px;

        .el-pagination__total {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #B8D1F0;
        }

        .btn-prev,
        .btn-next {

            border-radius: 4px 4px 4px 4px;
            border: 1px solid #849FC5;
            background: none;
            color: #fff;
        }

        .el-pager {
            .number {
                background: none;
                color: #B8D1F0;
            }

            .active {
                background: #1374FF;
                color: #B8D1F0;
            }
        }

        .el-pagination__jump {
            color: #B8D1F0;

            .el-input__inner {
                background: none;
                color: #fff;
            }
        }

    }

    .imgBox {
        font-weight: normal;
        font-size: 16px;
        color: #BDD9EC;

        .zsImg {
            display: inline-block;
            width: 120px;
            height: 80px;
            background: #C4C4C4;
            margin-left: 10px;
            vertical-align: top;
            margin-bottom: 10px;
        }
    }
</style>